'use client'

import { ScrollBarWrapper } from '@qr-front/ui/components/ScrollBarWrapper'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@qr-front/ui/components/Select'
import { useMemo } from 'react'

import { ROUTES } from '@/constants'

import { LanguageType } from '../../services/languages/languageTypes'
import { LanguageSelectDesktopTrigger } from './LanguageSelectDesktopTrigger'

type Props = {
	languageList: LanguageType[]
	locale: string
	langProxyRoute?: string
}

export const LanguageSelectQrDisabled = ({
	languageList,
	locale,
	langProxyRoute = ROUTES.qrDisabledLangProxy,
}: Props) => {
	const handleChange = (value: string) => {
		document.body.style.cursor = 'wait'
		window.location.href = `${langProxyRoute}?lang=${value}`
	}

	const sortedLanguages = useMemo(
		() => languageList.slice().sort((a, b) => a.name.localeCompare(b.name)),
		[languageList],
	)

	return (
		<Select onValueChange={handleChange} value={locale}>
			<LanguageSelectDesktopTrigger
				languageList={languageList}
				showLabelAs="name"
				locale={locale}
				Container={SelectTrigger}
				ValueWrapper={SelectValue}
			/>
			<SelectContent
				className="right-10 h-49 max-h-49 w-40 max-w-40 border-none bg-white p-2 shadow-icon"
				position="popper"
			>
				<ScrollBarWrapper
					scrollbarMinSize={18}
					className="h-full"
					childrenClassNames="mr-3"
				>
					{sortedLanguages.map((lang) => (
						<SelectItem
							key={lang.code}
							value={lang.code}
							data-state={lang.code === locale ? 'checked' : 'unchecked'}
							aria-selected={lang.code === locale ? 'true' : 'false'}
						>
							{lang.name}
						</SelectItem>
					))}
				</ScrollBarWrapper>
			</SelectContent>
		</Select>
	)
}
